import { Box, makeStyles, Typography } from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import EyeIcon from '@material-ui/icons/RemoveRedEye'

const FAKE_VIEWS = [2, 3, 4]
const INTERVAL_PERIODS_SEC = [30, 45, 15, 10 ]

const useStyles = makeStyles(({breakpoints, spacing})=>({
  root: {
    backgroundColor: 'rgba(108, 99, 255, 0.08)',
    padding: spacing(1.5),
    borderRadius: 4,
    [breakpoints.up('md')]:{
      maxWidth: 300
    }
  },
  icon: {
    fontSize: 24
  }
}))

const getViews = () => {
  return FAKE_VIEWS[Math.floor(Math.random() * FAKE_VIEWS.length)];
}

const getInterval = () => {
  return INTERVAL_PERIODS_SEC[Math.floor(Math.random() * INTERVAL_PERIODS_SEC.length)] * 1000;
}

export const CurrentViews: React.FC = () => {
  const classes = useStyles()
  const [views, setViews] = useState(getViews())
  useEffect(()=>{
    const intervalPeriod = getInterval()
    const intervalId = setInterval(()=>{
      const viewsNumber = getViews()
      setViews(viewsNumber)
    }, intervalPeriod)

    return () => clearInterval(intervalId)
  }, [views])  


  return (
    <Box className={classes.root} display="flex" alignItems="center">
      <EyeIcon color="primary" className={classes.icon} />
      <Box mr={1.5} />
      <Typography variant="subtitle2" color="primary">{`${views} people are viewing now`}</Typography>
    </Box>
  )
}